// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';
import { Typography } from '@kintent/glide';
import styled from '@emotion/styled';

import { Flex } from './Flex';
import { BREAKPOINTS, TRUSTCLOUD_WEBSITE_URL } from '../lib/constants';

// Assets
import trustCloudLogo from '../assets/home/trustcloud-logo.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  & .tc-footer-blurb {
    width: 380px;
    text-align: center;
  }

  & > div {
    cursor: pointer;
    transition: transform ease-in 150ms;

    :hover {
      transform: translateY(-2px);
    }
  }

  @media (min-width: ${BREAKPOINTS.TABLET}px) {
    & {
      flex-direction: row;
      gap: 48px;

      & .tc-footer-blurb {
        text-align: initial;
      }
    }
  }
`;

const StyledLink = styled.a`
  color: ${({ theme }) => theme.components.header.primaryCTAButton.background};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

function TrustCloudFooterBranding() {
  const openTCWebsite = () => {
    window.open(TRUSTCLOUD_WEBSITE_URL, '_blank');
  };

  return (
    <Wrapper>
      <Flex
        direction="column"
        gap="8px"
        onClick={openTCWebsite}
      >
        <Typography
          as="p"
          level="8"
          strength="60%"
        >
          Accurately crafted by
        </Typography>
        <img
          src={trustCloudLogo}
          alt="TrustCloud Logo"
          height={38}
        />
      </Flex>
      <Typography
        level="8"
        strength="60%"
        className="tc-footer-blurb"
      >
        Accelerate revenue and earn trust with your own unified, joyfully-crafted trust assurance platform.{' '}
        <StyledLink
          href={TRUSTCLOUD_WEBSITE_URL}
          target="_blank"
        >
          Learn More
        </StyledLink>
      </Typography>
    </Wrapper>
  );
}

export default TrustCloudFooterBranding;
